import { useEffect, useState } from "react";

// Generic — any page wiring a search input to a real API needs this same
// "don't fire a request per keystroke" behavior.
export const useDebouncedValue = <T,>(value: T, delayMs = 400): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return debounced;
};
